/* eslint-disable */

export enum CustomerPageSection {
	Unknown = 0,
	OrderHistory = 1,
	Favourites = 2,
	Login = 3,
	Account = 4,
	Register = 5,
	PasswordReset = 6,
	ActivateAccount = 7,
	EnterNewPassword = 8,
	ConnectAccount = 9,
	Return = 10,
	ReturnComplete = 11,
	Payment = 12,
	Changes = 13,
	PriceMatch = 14,
	PriceMatchComplete = 15,
	Claims = 16,
	Deliveries = 17,
	DeliveriesComplete = 18,
	ChangesComplete = 19,
	ClaimsComplete = 20,
	Rental = 21,
	ShippingDamage = 22,
	ShippingDamageComplete = 23,
	
}
